import { Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-error',
  imports: [MatDialogModule, MatButtonModule],
  templateUrl: './error.dialog.html',
  styleUrl: './error.dialog.scss',
})
export class ErrorDialog {
  constructor(@Inject(MAT_DIALOG_DATA) public data: { title: string; description: string }, public dialogRef: MatDialogRef<ErrorDialog>) {}

  close(): void {
    this.dialogRef.close();
  }
}
